import { BillingEstimate, BillingEstimateParams } from '@recruitee/http-types';
import { createSingleEntityStore, PickActions, pipeState } from '@recruitee/ngrx';

const { actions, namespace, reducer, selectors } = createSingleEntityStore<BillingEstimate>()(
  'BillingEstimate',
  {
    customActions: adapter => ({
      fetch: (state, payload: BillingEstimateParams) =>
        pipeState(adapter.reset(), next => adapter.markAsPending(next)),
    }),
  },
);

const BillingEstimateActions: PickActions<typeof actions, 'fetch'> = actions;

export {
  BillingEstimateActions,
  namespace as BillingEstimateNamespace,
  reducer as BillingEstimateReducer,
  selectors as BillingEstimateSelectors,
};
